const BulkAlertingResourceType = {
  SHARED_THRESHOLD: 'alert',
  QUIET_TIME: 'quietTime',
  NOTIFICATION_GROUP: 'notificationGroup',
  NOTIFICATION_TEMPLATE: 'notificationTemplate',
};

// eslint-disable-next-line import/prefer-default-export
export { BulkAlertingResourceType };
